import React from 'react';
import Chart from 'react-apexcharts'
import Utils from '../../providers/Utils';


export default class ChartsChestionare extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

            viewChart: true,
            series:

                this.props.raspunsuri.map((r, idx) => {
                    return { name: r.label_optiune_raspuns, data: r.rezultate }
                })

            ,
            options: {
                chart: {
                    // height: 350,
                    width: '90%',
                    
                    type: 'bar',
                    toolbar: {
                        show: false,
                        offsetX: 0,
                        offsetY: 0,
                        tools: {
                            download: false,
                            selection: true,

                        }
                    },


                },

                colors: ['rgba(0, 227, 150, 0.85)', 'rgba(255, 69, 96)', 'rgba(254, 176, 25, 0.85)', 'rgba(38, 166, 154)', 'rgba(0, 143, 251, 0.85)'],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        legend: {
                            position: 'bottom',
                            offsetX: -10,
                            offsetY: 0
                        }
                    }
                }],
                plotOptions: {
                    bar: {
                        horizontal: false,
                        dataLabels: {
                            position: 'bottom', // top, center, bottom
                        },
                        borderRadius: 8,
                        columnWidth: this.barWidth(),
                        endingShape: "rounded",
                        colors: {
                            backgroundBarColors: ['red', 'blue', 'green', 'yellow'],
                            backgroundBarOpacity: 0,
                            backgroundBarRadius: 0,
                        }
                    }
                },
                legend: {
                    show: false
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ["transparent"]
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val, idx,) {
                        // console.log('idx :>> ', idx.w);
                        // console.log('val :>> ', val);

                        if (val < 2) {
                            let sumSeries = 0

                            for (let i = 0, n = idx.w.config.series.length; i < n; i++) {
                                // console.log('idx.w.config.series[i].data[idx.dataPointIndex] :>> ', idx.w.config.series[i].data[idx.dataPointIndex]);

                                sumSeries += idx.w.config.series[i].data[idx.dataPointIndex]
                            }

                            // console.log('sumSeries :>> ', sumSeries);
                            if (sumSeries > 100) {
                                return idx.w.config.labels[idx.seriesIndex] + 0 + '%'
                            } else {
                                return idx.w.config.labels[idx.seriesIndex] + val + '%'
                            }
                        } else {
                            return idx.w.config.labels[idx.seriesIndex] + val + '%'
                        }



                        // console.log('idx :>> ', idx);
                     

                    },
                    offsetY: 5,
                    floating: true,
                    style: {
                        fontSize: '9px',
                        colors: ["#ffffff"]
                    }
                },
                labels: this.props.raspunsuri.map((r, idx) => {


                    return this.u.alfabet[idx] + ')'
                }),



                xaxis: {
                    categories: this.props.raspunsuri[0].rezultate_evaluare,
                    labels: {
                        offsetX: 0,
                        offsetY: 0,
                    },
                    position: 'top',
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    },
                    crosshairs: {
                        fill: {
                            type: 'gradient',
                            gradient: {
                                colorFrom: '#D8E3F0',
                                colorTo: '#BED1E6',
                                stops: [0, 100],
                                opacityFrom: 0.4,
                                opacityTo: 0.5,
                            }
                        }
                    },
                    tooltip: {
                        enabled: false,
                    },
                    lines: {
                        show: true,
                    }

                },

                grid: {
                    yaxis: {
                        lines: {
                            show: true,
                        }
                    },
                    xaxis: {
                        lines: {
                            show: true,
                        }
                    },
                  margin:{
                      left:0,
                      rigth:0
                  }
                },
                yaxis: {
                    min: 0,
                    max: 100,
                    axisBorder: {
                        show: true
                    },
                    axisTicks: {
                        show: true,
                    },
                    labels: {
                        show: true,
                        formatter: function (val, idx) {

                            // console.log('idx dataLabel :>> ', idx);


                            if (idx) {

                                if (val < 2) {
                                    let sumSeries = 0

                                    for (let i = 0, n = idx.w.config.series.length; i < n; i++) {
                                        // console.log('idx.w.config.series[i].data[idx.dataPointIndex] :>> ', idx.w.config.series[i].data[idx.dataPointIndex]);

                                        sumSeries += idx.w.config.series[i].data[idx.dataPointIndex]
                                    }

                                    // console.log('sumSeries :>> ', sumSeries);
                                    if (sumSeries > 100) {
                                        return 0 + '%'
                                    } else {
                                        return val + '%'
                                    }
                                } else {
                                    return val + "%";
                                }

                            }


                        }
                    },


                },
                title: {
                    text: 'Monthly Inflation in Argentina, 2002',
                    floating: true,
                    offsetY: - 50,
                    align: 'center',
                    style: {
                        color: '#444'
                    }
                }
            },

        }
    }

    u = new Utils()



    viewChart = true






    chartWidth = () => {

        console.warn('this.props.raspunsuri :>> ', this.props.raspunsuri);

        let chartContainer = document.getElementById('chart')
        console.log('chartContainer :>> ', chartContainer);

        // let chartContainerWidth = chartContainer.offsetWidth
        // console.log('chartContainerWidth :>> ', chartContainerWidth);


        let chartWidth = 0


        if (this.props.raspunsuri[0].rezultate.length > 1) {

            for (let i = 0, n = this.props.raspunsuri.length; i < n; i++) {
                chartWidth += 150

                for (let j = 0, m = this.props.raspunsuri[i].rezultate.length; j < m; j++) {

                    chartWidth += 70
                }
            }

        } else {
            chartWidth = '100%'
        }

        console.log('chartWidth :>> ', chartWidth);

        if(chartWidth < 1000){
            chartWidth = '100%'
        }

        return chartWidth
    }


    barWidth = () => {

        console.warn('this.props.raspunsuri :>> ', this.props.raspunsuri);


        // let barWidth = 0


        // if (this.props.raspunsuri[0].rezultate.length === 1) {

        //     barWidth = this.props.raspunsuri.length * 5 + 'px'


        // } else {

        //     barWidth = this.chartWidth() / this.props.raspunsuri.length / this.props.raspunsuri[0].rezultate.length + 'px'


        // }

        // console.log('barWidth :>> ', barWidth);

        return '50px'

    }


    changeRender = () => {

        if(this.props.loading){

            this.props.startLoading()
        }


        console.warn('change RENDER')
        let series = this.props.raspunsuri.map((r, idx) => {
            return { name: r.label_optiune_raspuns, data: r.rezultate }
        })


        let options = {
            chart: {
                // height: 350,
                width: '90%',
                type: 'bar',
                toolbar: {
                    show: false,
                    offsetX: 0,
                    offsetY: 0,
                    tools: {
                        download: false,
                        selection: true,

                    }
                },


            },
            responsive: [{
                breakpoint: 480,
                options: {
                    legend: {
                        position: 'bottom',
                        offsetX: -10,
                        offsetY: 0
                    }
                }
            }],
            plotOptions: {
                bar: {
                    horizontal: false,
                    dataLabels: {
                        position: 'bottom', // top, center, bottom
                    },
                    borderRadius: 8,
                    columnWidth: this.barWidth(),
                    endingShape: "rounded",
                    colors: {
                        backgroundBarColors: ['red', 'blue', 'green', 'yellow'],
                        backgroundBarOpacity: 0,
                        backgroundBarRadius: 0,
                    }
                }
            },
            legend: {
                show: false
            },
            stroke: {
                show: true,
                width: 2,
                colors: ["transparent"]
            },
            dataLabels: {
                enabled: true,
                formatter: function (val, idx,) {
                    // console.log('idx :>> ', idx.w);
                    if (val < 2) {
                        let sumSeries = 0

                        for (let i = 0, n = idx.w.config.series.length; i < n; i++) {
                            // console.log('idx.w.config.series[i].data[idx.dataPointIndex] :>> ', idx.w.config.series[i].data[idx.dataPointIndex]);

                            sumSeries += idx.w.config.series[i].data[idx.dataPointIndex]
                        }

                        // console.log('sumSeries :>> ', sumSeries);
                        if (sumSeries > 100) {
                            return idx.w.config.labels[idx.seriesIndex] + 0 + '%'
                        } else {
                            return idx.w.config.labels[idx.seriesIndex] + val + '%'
                        }
                    } else {
                        return idx.w.config.labels[idx.seriesIndex] + val + '%'
                    }

                },
                offsetY: 5,
                floating: true,
                style: {
                    fontSize: '9px',
                    colors: ["#e3e3e3"]
                }
            },
            labels: this.props.raspunsuri.map((r, idx) => {
                return this.u.alfabet[idx] + ')'
            }),

            grid: {
                yaxis: {
                    lines: {
                        show: true,
                    }
                },
                xaxis: {
                    lines: {
                        show: true,
                    }
                }
            },

            xaxis: {
                categories: this.props.raspunsuri[0].rezultate_evaluare,
                labels: {
                    offsetX: 0,
                    offsetY: 0,
                },
                position: 'top',
                axisBorder: {
                    show: false
                },
                axisTicks: {
                    show: false
                },
                crosshairs: {
                    fill: {
                        type: 'gradient',
                        gradient: {
                            colorFrom: '#D8E3F0',
                            colorTo: '#BED1E6',
                            stops: [0, 100],
                            opacityFrom: 0.4,
                            opacityTo: 0.5,
                        }
                    }
                },
                tooltip: {
                    enabled: false,
                },

            },
            yaxis: {
                min: 0,
                max: 100,
                axisBorder: {
                    show: true
                },
                axisTicks: {
                    show: true,
                },
                labels: {
                    show: true,
                    formatter: function (val, idx) {

                        // console.log('idx dataLabel :>> ', idx);


                        if (idx) {

                            if (val < 2) {
                                let sumSeries = 0

                                for (let i = 0, n = idx.w.config.series.length; i < n; i++) {
                                    // console.log('idx.w.config.series[i].data[idx.dataPointIndex] :>> ', idx.w.config.series[i].data[idx.dataPointIndex]);

                                    sumSeries += idx.w.config.series[i].data[idx.dataPointIndex]
                                }

                                // console.log('sumSeries :>> ', sumSeries);
                                if (sumSeries > 100) {
                                    return 0 + '%'
                                } else {
                                    return val + '%'
                                }
                            } else {
                                return val + "%";
                            }

                        }


                    }
                },

            },
            title: {
                text: 'Monthly Inflation in Argentina, 2002',
                floating: true,
                offsetY: - 50,
                align: 'center',
                style: {
                    color: '#444'
                }
            }
        }


        // console.log('raspunsREzultate :>> ', this.props.raspunsuri[0].rezultate_evaluare);





        this.setState({ series: series, options: options }, ()=>{

            if(this.props.loading){

                this.props.stopLoading()
            }
        })
    }



    render() {
        return (


            <div style={{ background: 'white', width: '100%', overflowX: 'scroll', overflowY:'hidden' }} id="chart" className='scroll-detaliu'>


                <Chart
                    style={{ margin: 'auto' }}
                    options={this.state.options}
                    series={this.state.series}
                    type="bar"
                    width={this.chartWidth()}
                    height={400}
                />


            </div>


        );
    }
}